import { AuthedAxiosRequests } from 'features/auth'

export interface RautGDriveRolodexSyncData {
  folder_id: string
  inspection_slug: string
  enable_auto_measure?: boolean
  reprocess_ascan?: boolean
  batch?: boolean
}

export const triggerGDriveRolodexSync = async (
  rautGDriveRolodexSyncUrl: string,
  axios: AuthedAxiosRequests,
  data: RautGDriveRolodexSyncData
) => {
  return await axios.post(`${rautGDriveRolodexSyncUrl}/`, data, {
    headers: { 'Content-Type': 'application/json' },
  })
}
